import React, { memo } from 'react';
import propTypes from 'prop-types';
import './button.scss';
import { LoadingButton } from '../../../component';

const Button = (props) => {
  const {
    intl,
    disabled,
    onClick,
    className,
    label,
    type,
    loading,
    dataTarget,
    dataToggle,
    tabIndex = '',
    name,
    id,
    labelClassName,
  } = props;
  return (
    <button
      name={name}
      id={id}
      tabIndex={tabIndex}
      className={`${className} loading-button button font-msmall w-100 default-border-radius-small d-flex flex-row justify-content-center`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      data-toggle={dataToggle}
      data-target={dataTarget}
    >
      {loading ? (
        <LoadingButton />
      ) : (
        <span className={labelClassName}>{label}</span>
        // intl.formatMessage({ id: label, defaultMessage: label })
      )}
    </button>
  );
};
Button.propTypes = {
  name: propTypes.string,
  id: propTypes.string,
  label: propTypes.string,
  disabled: propTypes.bool,
  type: propTypes.string,
  className: propTypes.string,
  loading: propTypes.bool,
  dataTarget: propTypes.string,
  dataToggle: propTypes.string,
  tabIndex: propTypes.string,
};
Button.defaultProps = {
  label: '',
  disabled: false,
  className: 'btn-primary',
  onClick: () => {},
  loading: false,
  type: 'button',
  dataTarget: '',
  dataToggle: '',
  tabIndex: '',
};

export default memo(Button);
